import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export const useDeleteAttendeeNote = (
  options?: UseMutationOptions<void, unknown, number, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (id: number) =>
      axiosInstance.delete(getAPIURL(`/AttendeeNote/${id}`)).then(() => undefined),
  });
};
